(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jta-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jta-countdown')) {
    const ART_OFFSET_MS = 3 * 60 * 60 * 1000;

    customElements.define(
      'jta-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.daysEl = this.querySelector('[data-days]');
          this.daysValueEl = this.querySelector('[data-days-value]');
          this.hoursEl = this.querySelector('[data-hours]');
          this.minutesEl = this.querySelector('[data-minutes]');
          this.secondsEl = this.querySelector('[data-seconds]');
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        target(now) {
          if (this.dataset.mode === 'daily_cutoff') {
            const hour = Number(this.dataset.cutoffHour) || 0;
            const artNow = new Date(now - ART_OFFSET_MS);
            const weekdaysOnly = this.dataset.weekdaysOnly === 'true';
            let cutoff = Date.UTC(artNow.getUTCFullYear(), artNow.getUTCMonth(), artNow.getUTCDate(), hour) + ART_OFFSET_MS;
            const isClosed = (time) => {
              const day = new Date(time - ART_OFFSET_MS).getUTCDay();
              return weekdaysOnly && (day === 0 || day === 6);
            };
            while (cutoff <= now || isClosed(cutoff)) cutoff += 24 * 60 * 60 * 1000;
            return cutoff;
          }
          const end = Date.parse(this.dataset.end);
          return Number.isNaN(end) ? null : end;
        }

        tick() {
          const now = Date.now();
          const end = this.target(now);
          if (end === null || end <= now) {
            this.hidden = true;
            clearInterval(this.timer);
            return;
          }
          const total = Math.floor((end - now) / 1000);
          const days = Math.floor(total / 86400);
          const pad = (n) => String(n).padStart(2, '0');
          this.daysEl.hidden = days === 0;
          this.daysValueEl.textContent = days;
          this.hoursEl.textContent = pad(Math.floor((total % 86400) / 3600));
          this.minutesEl.textContent = pad(Math.floor((total % 3600) / 60));
          this.secondsEl.textContent = pad(total % 60);
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jta-objections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jta-objections-carousel')) {
    customElements.define(
      'jta-objections-carousel',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.jta-obj');
          if (!section) return;
          this.prevButton = section.querySelector('[data-jta-obj-prev]');
          this.nextButton = section.querySelector('[data-jta-obj-next]');
          this.onPrev = () => this.move(-1);
          this.onNext = () => this.move(1);
          this.onScroll = () => this.update();
          this.prevButton?.addEventListener('click', this.onPrev);
          this.nextButton?.addEventListener('click', this.onNext);
          this.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        }

        disconnectedCallback() {
          this.prevButton?.removeEventListener('click', this.onPrev);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.removeEventListener('scroll', this.onScroll);
        }

        move(direction) {
          const card = this.firstElementChild;
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this).columnGap || 0);
          this.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        update() {
          const maxScroll = this.scrollWidth - this.clientWidth - 2;
          if (this.prevButton) this.prevButton.disabled = this.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.scrollLeft >= maxScroll;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jta-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jta-reviews-carousel')) {
    customElements.define(
      'jta-reviews-carousel',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.jta-reviews');
          if (!section) return;
          this.prevButton = section.querySelector('[data-jta-prev]');
          this.nextButton = section.querySelector('[data-jta-next]');
          this.onPrev = () => this.move(-1);
          this.onNext = () => this.move(1);
          this.onScroll = () => this.update();
          this.prevButton?.addEventListener('click', this.onPrev);
          this.nextButton?.addEventListener('click', this.onNext);
          this.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        }

        disconnectedCallback() {
          this.prevButton?.removeEventListener('click', this.onPrev);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.removeEventListener('scroll', this.onScroll);
        }

        move(direction) {
          const card = this.firstElementChild;
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this).columnGap || 0);
          this.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        update() {
          const maxScroll = this.scrollWidth - this.clientWidth - 2;
          if (this.prevButton) this.prevButton.disabled = this.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.scrollLeft >= maxScroll;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
